import React, { useEffect, useState } from "react";
import CommonTable from "../../components/commonComponents/Table/CommonTable";
import Heading from "../../components/commonComponents/Heading/Heading";
import styles from "../Inventory/Inventory.module.css";
import { RiFileExcel2Fill } from "react-icons/ri";
import { FaFileCsv, FaFilePdf } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Grid,
  IconButton,
  Typography,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  CircularProgress,
  Box,
  Autocomplete,
} from "@mui/material";
import dayjs from "dayjs";
import { format } from "date-fns";
import {
  generateCSV,
  generateExcel,
  generatePDF,
  handleCsvGeneration,
} from "../../utils/exportUtils";
import SearchField from "../../components/commonComponents/SearchField/SearchField";
import { useDispatch } from "react-redux";
import { Spinner } from "../../components/commonComponents/Spinner/Spinner";
import AddIcon from "@mui/icons-material/Add";
import api from "../../components/commonComponents/axiosSetup";
import { toast } from "react-toastify";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { getSMSWhitelist } from "../whiteListing/utility";
import {
  accountName,
  isSuperAdmin,
  userPermissions,
} from "../customerManagement/utility/authUtils";
import CommonFilter from "../../components/commonComponents/commonFilter";
import { fetchTickets, updateTicket } from "./utility";
import HelpBadge from "./HelpBadge";
import { ChatBubbleOutline, Person } from "@mui/icons-material";
import { motion } from "framer-motion";

const tableCss = {
  moduleHeight: "37.9rem",
  cellPadding: "12px 16px",
  tableWidth: "100%!important",
};

const permissions = userPermissions()?.dashboardMenu?.whitelisting?.edit;

const buttonArray = [
  { name: null, key: "excel", icon: <RiFileExcel2Fill /> },
  { name: null, key: "csv", icon: <FaFileCsv /> },
  { name: null, key: "pdf", icon: <FaFilePdf /> },
  { name: "Filter", key: "filter" },
  {
    name: "Create New",
    key: "create_new",
    icon: <AddIcon />,
    // visible: !isSuperAdmin() && permissions,
  },
];
const pageVariants = {
  initial: { opacity: 0, y: 20 },
  in: { opacity: 1, y: 0 },
  out: { opacity: 0, y: -20 }
};

const pageTransition = {
  type: "tween",
  ease: "anticipate",
  duration: 0.3
};
const SupportTicketsPanel = () => {
  const [columns] = useState([
    {
      name: "Select All",
      key: "selectAll",
      selected: true,
      showExcel: false,
      showTable: false,
      showPDF: false,
    },
    {
      name: "Sr. No",
      selected: true,
      key: "serial",
      showExcel: true,
      showTable: false,
      showPDF: true,
    },
    {
      name: "Request ID",
      selected: true,
      key: "ticketId",
      showExcel: true,
      showTable: true,
      showPDF: true,
      clickable: false,
    },
    {
      name: "Name",
      key: "name",
      showExcel: true,
      showTable: true,
      showPDF: true,
      selected: true,
    },
    {
      name: "Email",
      key: "email",
      showExcel: true,
      showTable: true,
      showPDF: true,
      selected: true,
    },

    {
      name: "Issue Type",
      selected: true,
      key: "issueType",
      showExcel: true,
      showTable: true,
      showPDF: true,
    },
    {
      name: "Status",
      selected: true,
      key: "status",
      showExcel: true,
      showTable: true,
      showPDF: true,
    },

    {
      name: "Submitted Date",
      selected: true,
      key: "date",
      showExcel: true,
      showTable: true,
      showPDF: true,
    },

    {
      name: "Actions",
      selected: true,
      key: "actions",
      showExcel: true,
      showTable: true,
      showPDF: true,
    },
  ]);

  const [inventoryList, setInventoryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [assignModal, setAssignModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [csvData, setCsvData] = useState(null);
  const [search, setSearch] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [editRowData, setEditRowData] = useState(null);
  const [showCard, setShowCard] = useState(false);
  const [generaldata, setGeneralData] = useState("General data");
  const [selectedRow, setSelectedRow] = useState(null);

  const [flattenData, setFlattenData] = useState([]);
  const [numberListData, setNumberListData] = useState([]);
  const [requestList, setRequestList] = useState([]);

  const [filters, setFilters] = useState({
    fromDate: dayjs(new Date()),
    toDate: dayjs(new Date()),
    pageNo: 0,
    pageSize: 10,
    search: "",
  });
  const [searchTerm, setSearchTerm] = useState();

  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const [showCustomFilterCard, setShowCustomFilterCard] = useState(false);
  const [response, setResponse] = useState("");
  const [statusOption, setStatusOption] = useState("In Progress");
  const [responding, setResponding] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleStatusChange = (e) => {
    setStatusOption(e.target.value);
  };

  const handleResponseChange = (e) => {
    setResponse(e.target.value);
  };

  const handleCloseDialog = () => {
    setModalOpen(false);
    setResponse("");
  };

  const handleButtonAction = (action) => {
    switch (action) {
      case "create_new":
        setOpen(true);
        setEditRowData(null);
        break;
      case "filter":
        setShowCustomFilterCard(true); // ✅ Only open custom filter popup
        break;
      case "assign_inventory":
        setAssignModal(true);
        break;
      case "upload_inventory":
        setUploadModal(true);
        break;
      case "excel":
        generateExcel(numberListData, columns, "inventory_data.xlsx");
        break;
      case "pdf":
        generatePDF(numberListData, columns, "inventory_data.pdf");
        break;
      case "csv":
        const data = handleCsvGeneration(numberListData, columns);
        setCsvData(data);
        break;
      default:
        console.log("Unknown action:", action);
    }
  };

  let sender;
  if (isSuperAdmin()) {
    sender = "Support";
  } else {
    sender = accountName();
  }
  const handleSubmitResponse = async () => {
    if (!response.trim() || !selectedRow) return;

    setResponding(true);
    try {
      const timestamp = new Date().toISOString();
      const newResponse = {
        sender: sender,
        message: response,
        timestamp,
      };

      // Prepare payload for API
      const payload = {
        ticketId: selectedRow.ticketId,
        message: response,
        status: isSuperAdmin() ? statusOption : selectedRow.status,
        sender: sender,
      };

      // Make API call (adjust endpoint and method as needed)
      // await api.put(`/support-tickets/${selectedRow.id}/respond`, payload);
      try {
        const res = await updateTicket(payload);
        if (res && (res.status === 200 || res.status === 201)) {
          handleTicketCreated();
          toast.success(`Response submitted successfully`);
          handleCloseModal();
        } else {
          throw new Error("Update failed");
        }
        console.log("Ticket created/updated:", res);
      } catch (error) {
        console.error("Failed to create ticket:", error);
      }

      handleCloseModal();
    } catch (error) {
      console.error("Failed to submit response:", error);
      toast.error("Failed to submit response");
    } finally {
      setResponding(false);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      // Simulate API call
      const respone = await fetchTickets();
      console.log(respone);

      setNumberListData(respone ? respone : []);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch support tickets");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleTicketCreated = () => {
    fetchData();
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setResponse("");
    setStatusOption("In Progress");
  };

  useEffect(() => {
    const searchTermLower = filters.search?.toLowerCase() || "";
    const filteredData = searchTermLower
      ? numberListData.filter((item) =>
          Object.values(item).some((val) => {
            if (typeof val === "string") {
              return val.toLowerCase().includes(searchTermLower);
            }
            if (typeof val === "number") {
              return val.toString().includes(searchTermLower);
            }
            return false;
          })
        )
      : numberListData;
    setTotalRows(filteredData.length);
    const startIndex = filters.pageNo * filters.pageSize;
    const endIndex = startIndex + filters.pageSize;
    const paginatedData = filteredData.slice(startIndex, endIndex);
    const list = paginatedData.map((item, index) => ({
      ...item,
      actions: getActionIcons(item, index),
    }));
    setRequestList(list ? list : []);
  }, [filters, numberListData]);

  const getActionIcons = (rowData, index) => (
    <Box sx={{ display: "flex", gap: 1 }}>
      <IconButton
        size="small"
        title="Respond"
        onClick={(e) => {
          e.stopPropagation();
          handleRespondClick(rowData);
        }}
      >
        <PlayArrowIcon
          size={18}
          sx={{
            color: rowData.status === "Closed" ? "gray" : "blue",
          }}
        />
      </IconButton>
      <IconButton
        size="small"
        title="View Details"
        onClick={(e) => {
          e.stopPropagation();
          handleViewDetailsClick(rowData);
        }}
      >
        <VisibilityIcon
          size={18}
          sx={{
            color: "#1976d2",
          }}
        />
      </IconButton>
    </Box>
  );

  const handleRespondClick = (rowData) => {
    if (rowData.status === "Closed") {
      toast.info("This ticket is already closed");
      return;
    }
    setSelectedRow(rowData);
     setStatusOption(rowData.status);
  console.log(rowData)
    setModalOpen(true);
  };

  const handleViewDetailsClick = (rowData) => {
    // Navigate to ViewDetails page with the ticket data
    navigate("/viewDetails", { state: { ticketData: rowData } });
  };

  const statusOptions = [
    "Open",
    "In Progress",
    "Pending User Input",
    "Resolved",
    "Closed",
  ];
  return (
    <>
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      {loading && <Spinner />}
      <div className={styles.headingContainer}>
        <Heading
          data={requestList}
          heading="Support"
          showSearch={true}
          arrowRedirection={false}
          showToFromDate={false}
          buttonArray={buttonArray}
          handleButtonAction={handleButtonAction}
          setSearchTerm={setSearchTerm}
          searchTerm={searchTerm}
          setFilters={setFilters}
          filters={filters}
        />
      </div>

      {showCustomFilterCard && (
        <CommonFilter
          show={showCustomFilterCard}
          onClose={() => {
            setShowCustomFilterCard(false);
            // setInventoryList(originalInventoryList); // Reset table to original
          }}
          data={numberListData} // Use unfiltered data for filtering
          filterFields={[
            { key: "status", label: "Status" },
            { key: "issueType", label: "Issue Type" },
          ]}
          onFilter={(filteredData) => {
            const flattened = filteredData.map((item, index) => ({
              ...item,
              actions: getActionIcons(item, index),
            }));
            setRequestList(flattened);
          }}
        />
      )}
      <div className={styles.container}>
        <CommonTable
          columns={columns}
          data={requestList}
          setData={setRequestList}
          tableCss={tableCss}
          filters={filters}
          totalRows={totalRows}
          showsort={true}
          onPageChange={(e, newPage) =>
            setFilters({ ...filters, pageNo: newPage })
          }
          onRowsPerPageChange={(e) =>
            setFilters({
              ...filters,
              pageNo: 0,
              pageSize: parseInt(e.target.value, 10),
            })
          }
          handleGetById={(data, ind) => console.log(data, ind)}
          iscard={true}
          onRowClick={(row) => {
            console.log("Row clicked 👉", row);
            setSelectedRow(row);
            setShowCard(true);
          }}
        />
      </div>

      {/* Support Ticket Response Dialog */}
      <Dialog
        open={modalOpen && selectedRow !== null}
        onClose={handleCloseModal}
        fullWidth
        maxWidth="md"
      >
        {selectedRow && (
          <>
            <DialogTitle sx={{ bgcolor: "var(--bg)", color: "white" }}>
              Ticket #{selectedRow.ticketId}
            </DialogTitle>
            <DialogContent sx={{ p: 3, mt: 2 }}>
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle1" fontWeight={600}>
                  User Information
                </Typography>
                <Typography>Name: {selectedRow.name}</Typography>
                <Typography>Email: {selectedRow.email}</Typography>
              </Box>

              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Issue Details
                </Typography>
                <Typography>Type: {selectedRow.issueType}</Typography>
                <Typography>Status: {selectedRow.status}</Typography>
                {/* <Typography>Page URL: {selectedRow.pageUrl}</Typography> */}
                <Typography>Date: {selectedRow.date}</Typography>
              </Box>

              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle1" fontWeight={600}>
                  Description
                </Typography>
                <Paper variant="outlined" sx={{ p: 2, bgcolor: "#f9f9f9" }}>
                  <Typography whiteSpace="pre-wrap">
                    {selectedRow.description}
                  </Typography>
                </Paper>
              </Box>

              {selectedRow.conversations &&
                selectedRow.conversations.length > 0 && (
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle1" fontWeight={600}>
                      Conversation History
                    </Typography>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2, maxHeight: "200px", overflowY: "auto" }}
                    >
                      {selectedRow.conversations.map((msg, index) => (
                        <Box
                          key={index}
                          sx={{
                            mb: 2,
                            pb: 2,
                            borderBottom:
                              index < selectedRow.conversations.length - 1
                                ? "1px solid #eee"
                                : "none",
                          }}
                        >
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mb: 1 }}
                          >
                            {msg.sender} •{" "}
                            {/* {format(
                              new Date(msg.time),
                              "MMM dd, yyyy HH:mm"
                            )} */}
                            {selectedRow.date}
                          </Typography>
                          <Typography whiteSpace="pre-wrap">
                            {msg.message}
                          </Typography>
                        </Box>
                      ))}
                    </Paper>
                  </Box>
                )}

              <Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <Person fontSize="small" />
                  <Typography variant="subtitle1" fontWeight={600}>
                    Response
                  </Typography>
                </Box>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  value={response}
                  onChange={handleResponseChange}
                  placeholder="Type your response here..."
                  variant="outlined"
                  sx={{ mt: 1, mb: 2 }}
                />

                {isSuperAdmin() && (
                  <>
                    <Typography variant="subtitle1" fontWeight={600}>
                      Update Status
                    </Typography>
                    <Autocomplete
                      options={statusOptions}
                      value={statusOption} 
                      onChange={(e, newValue) =>
                        setStatusOption(newValue || "")
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Status"
                          placeholder="Select or search status"
                          variant="outlined"
                        />
                      )}
                      sx={{ mt: 1 }}
                      fullWidth
                    />
                  </>
                )}
              </Box>

              {selectedRow.screenshot && (
                <Box sx={{ mb: 3, marginTop: 2 }}>
                  <Typography variant="subtitle1" fontWeight={600}>
                    Attachment
                  </Typography>
                  <Box sx={{ mt: 1 }}>
                    {selectedRow.screenshot.toLowerCase().endsWith(".pdf") ? (
                      <Box sx={{ border: "1px solid #eee", p: 1 }}>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ mb: 1 }}
                        >
                          PDF Document attached
                        </Typography>
                        <Button
                          variant="outlined"
                          size="small"
                          startIcon={<FaFilePdf />}
                          href={selectedRow.screenshot}
                          target="_blank"
                          sx={{ mr: 1 }}
                        >
                          Open PDF
                        </Button>
                        {/* <Button
                          component="a"
                          variant="text"
                          size="small"
                          href={selectedRow.screenshot}
                          download="attachment.pdf"
                        >
                          Download
                        </Button> */}
                      </Box>
                    ) : selectedRow.screenshot.toLowerCase().endsWith(".doc") ||
                      selectedRow.screenshot.toLowerCase().endsWith(".docx") ? (
                      <Box sx={{ border: "1px solid #eee", p: 1 }}>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ mb: 1 }}
                        >
                          Word Document attached
                        </Typography>
                        <Button
                          variant="outlined"
                          size="small"
                          href={`https://docs.google.com/viewer?url=${encodeURIComponent(
                            selectedRow.screenshot
                          )}&embedded=true`}
                          target="_blank"
                          sx={{ mr: 1 }}
                        >
                          Preview
                        </Button>
                        <Button
                          variant="text"
                          size="small"
                          href={selectedRow.screenshot}
                          download="attachment.doc"
                        >
                          Download
                        </Button>
                      </Box>
                    ) : (
                      // Default to image rendering for all other formats
                      <img
                        src={selectedRow.screenshot}
                        alt="User screenshot"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "300px",
                          border: "1px solid #eee",
                        }}
                      />
                    )}
                  </Box>
                </Box>
              )}
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button sx={{ color: "var(--bg)" }} onClick={handleCloseModal}>
                Cancel
              </Button>
              {selectedRow.status !== "Closed" && (
                <>
                  {isSuperAdmin() && (
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => {
                        setStatusOption("Closed");
                        if (!response.trim()) {
                          setResponse("This ticket has been closed.");
                        }
                      }}
                    >
                      Close Ticket
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    onClick={handleSubmitResponse}
                    disabled={!response.trim() || responding}
                    sx={{ backgroundColor: "var(--bg)" }}
                  >
                    {responding ? (
                      <CircularProgress size={24} />
                    ) : (
                      "Send Response"
                    )}
                  </Button>
                </>
              )}
            </DialogActions>
          </>
        )}
      </Dialog>

      {open && (
        <HelpBadge
          open={open}
          setOpen={setOpen}
          onTcketCreated={handleTicketCreated}
        />
      )}
      {csvData && generateCSV(csvData, "inventory_data.csv")}
      </motion.div>
    </>
  );
};

export default SupportTicketsPanel;
